"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateFromHTML = stateFromHTML;
exports.stateToHTML = stateToHTML;
exports.stateToMarkdown = stateToMarkdown;
Object.defineProperty(exports, "stateFromMarkdown", {
  enumerable: true,
  get: function get() {
    return _draftJsImportMarkdown.stateFromMarkdown;
  }
});

var _draftConvert = require("draft-convert");

var _draftJsImportMarkdown = require("draft-js-import-markdown");

var _draftJsExportHtml = require("draft-js-export-html");

var _draftJsExportMarkdown = require("draft-js-export-markdown");

var parseOptions = {
  blockStyleFn: function blockStyleFn(block) {
    var data = block.getData(); // textAligns

    var textAlign = data.get('textAlign');

    if (textAlign) {
      return {
        style: {
          textAlign: textAlign
        }
      };
    }

    return null;
  }
};

function stateFromHTML(html) {
  return (0, _draftConvert.convertFromHTML)({
    // NOTE: Copied from https://github.com/HubSpot/draft-convert#convertfromhtml. Might need in the future
    // htmlToStyle: (nodeName, node, currentStyle) => {
    //   if (nodeName === 'span' && node.style.color === 'blue') {
    //     return currentStyle.add('BLUE');
    //   }
    //   return currentStyle;
    // },
    // textToEntity: (text, createEntity) => {
    //   const result = [];
    //   text.replace(/\@(\w+)/g, (match, name, offset) => {
    //     const entityKey = createEntity(
    //       'AT-MENTION',
    //       'IMMUTABLE',
    //       { name },
    //     );
    //     result.push({
    //       entity: entityKey,
    //       offset,
    //       length: match.length,
    //       result: match,
    //     });
    //   });
    //   return result;
    // },
    htmlToEntity: function htmlToEntity(nodeName, node, createEntity) {
      if (nodeName === 'a') {
        // link entity
        return createEntity('LINK', 'MUTABLE', {
          url: node.href,
          target: node.target
        });
      }

      return null;
    },
    htmlToBlock: function htmlToBlock(nodeName, node) {
      if (node && node.style) {
        var style = node.style; // textAligns

        var textAlign = style.textAlign;

        if (textAlign) {
          return {
            data: {
              textAlign: textAlign
            }
          };
        }
      }

      return null;
    }
  })(html);
}

function stateToHTML(html) {
  return (0, _draftJsExportHtml.stateToHTML)(html, parseOptions);
}

function stateToMarkdown(html) {
  return (0, _draftJsExportMarkdown.stateToMarkdown)(html, parseOptions);
}